/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import { GetterTree, MutationTree, ActionTree } from 'vuex';

interface State {
  fiConfig: any;
}

export const state: State = {
  fiConfig: {},
};

export const getters: GetterTree<State, any> = {
  //logoFullUrl: (state: State): string => state.fiConfig.logoFullUrl,
  logoFullUrl: (state: State): string => 'https://kcas-fi-config.dev.kasasaonline.com/fi/432/freedominstitute15008296401059720767.png',
};

export const mutations: MutationTree<State> = {
  SET_FICONFIG(state, newFiConfig) {
    state.fiConfig = newFiConfig;
  },
};

export const actions: ActionTree<State, any> = {
  getFiConfig({ commit }, fiId) {
    return fetch(`http://localhost:8080/public-gateway-proxy/api/v1/fi/${fiId}/kasasa-fiid`)
      .catch((error) => {
        console.error('errors: ', error);
      })
      .then((response: any) => {
        if (!response.ok) {
          throw new Error('Unable to reach API');
        }

        return response.json();
      })
      .then((response) => {
        commit('SET_FICONFIG', response.data);
      });
  },
};
